import React, { useEffect } from 'react';
import './PublicInfoPage.css';
import ScrollToTopButton from '../../components/ScrollToTopButton';

const AboutPage = () => {
  useEffect(() => {
    document.title = "Avisa";
  }, []);

  return (
    <div className="pip-root">
      <main className="pip-container">
        <div className="pip-card">
          <div className="pip-content-header">
            <h1 className="pip-title">About Avisa</h1>
            <p className="pip-subtitle">Our mission and project background</p>
          </div>

          <div className="pip-content-body">
            <section className="pip-section" style={{ marginBottom: 0 }}>
              <p style={{ fontSize: '16px', lineHeight: '1.85', color: '#475569', textAlign: 'justify' }}>
                Avisa is an AI-Enhanced Legal Information Management System designed to bridge the legal literacy gap in the Philippines by making national laws and local ordinances accessible to every Filipino citizen. Developed as a capstone project by students from National University, the platform transforms complex legal documents into plain-language summaries and Filipino translations using Google's Gemini AI, while preserving legal accuracy through expert verification. The system features a jurisdiction-aware search that prioritizes relevant barangay and municipal ordinances, a RAG-powered chatbot that answers legal questions with cited sources, and direct access to original scanned documents for verification. Built with a three-tier cloud-native architecture using React Native, React.js, and Firebase, Avisa serves both citizens seeking to understand their rights and Local Government Units needing efficient ordinance management tools. The platform aligns with UN Sustainable Development Goal 16 by promoting equal access to justice and strengthening transparency between the public and local institutions.
              </p>
            </section>

            <footer className="pip-footer" style={{ marginTop: '40px' }}>
              <p>© 2026 Avisa. All rights reserved.</p>
            </footer>
          </div>
        </div>
      </main>
      <ScrollToTopButton />
    </div>
  );
};

export default AboutPage;
